import React, { useContext, useEffect, useState } from 'react'
import { Container, Grid, IconButton, Paper, Typography } from '@mui/material';
import InputText from '../../../DevComponents/InputText';
import { ContextoGlobal, ContextoGlobalInterface } from '../../../GlobalStates/ContextoGlobal';
import Condicional from '../../../Layout/Condicional';
import Button from '@mui/material/Button';
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';

import DataTable, { DataTableCabecalhoInterface } from '../../../DevComponents/DataTable';
import { useNavigate } from 'react-router-dom';
import ClsCrud from '../../../Utils/ClsCrud';

import { StatusForm } from '../../../Utils/ClsCrud'
import ClsValidacao from '../../../Utils/ClsValidacao';
import { EMDESENVOLVIMENTO } from '../../../ImportBackend/Config/emDesenvolvimento';
import DataTableCrudJSON from '../../../DevComponents/DataTableCrudJSON';
import DrgCorrespondenciaDetalheJSON from './DRGCadastroCorrespondenciaConteudoPermitidoJSON';
import { DrgConteudoPermitidoInterface, DrgCorrespondenciaInterface } from '../../../ImportBackend/Interfaces/DrgInterfaces';
import ExibirJSONDev from '../../../DevComponents/ExibirJSONDev';
import ComboBox from '../../../DevComponents/ComboBox';
import { GrupoDRGTypes } from '../../../ImportBackend/types/ConstantesDataTypes';

interface PesquisaInterface {
  descricao: string
}

export default function DRGCadastroCorrespondencia() {

  const [statusForm, setStatusForm] = useState<StatusForm>(StatusForm.Pesquisando)

  const Cabecalho: Array<DataTableCabecalhoInterface> = [
    {
      campo: 'grupo',
      cabecalho: 'Grupo',
      alinhamento: 'left'
    },
    {
      campo: 'descricao',
      cabecalho: 'Descrição',
      alinhamento: 'left'
    },
    {
      campo: 'campo',
      cabecalho: 'Nome do Campo',
      alinhamento: 'left'
    },
    {
      campo: 'valorUnico',
      cabecalho: 'Valor Único',
      alinhamento: 'left',
      format: (valor: boolean) => (valor ? 'Sim' : 'Não')
    }
  ]

  const ResetDados: DrgCorrespondenciaInterface = {
    idDrgCorrespondencia: 0,
    descricao: '',
    campo: '',
    grupo: '',
    conteudoPermitido: [],
    valorUnico: false
  }

  const TituloForm = {
    [StatusForm.Incluindo]: 'Inclusão de nova correspondência do DRG',
    [StatusForm.Excluindo]: 'Exclusão de correspondência do DRG',
    [StatusForm.Pesquisando]: 'Correspondência do DRG são utilizados para fazer "de para" entre os campos do sistema e os campos do DRG',
    [StatusForm.Editando]: 'Alteração de dados de correspondência do DRG',
    [StatusForm.Exibindo]: 'Correspondência do DRG'
  }

  const contexto = useContext(ContextoGlobal) as ContextoGlobalInterface
  const { mensagemState, setMensagemState } = contexto

  const [dados, setDados] = useState<DrgCorrespondenciaInterface>(ResetDados)

  const [erros, setErros] = useState({})

  const [pesquisa, setPesquisa] = useState<PesquisaInterface>({ descricao: '' })

  const [rsPesquisa, setRsPesquisa] = useState<Array<DrgCorrespondenciaInterface>>([])

  const navigate = useNavigate()

  const validarDados = (): boolean => {

    let retorno: boolean = true
    let erros: { [key: string]: string } = {}

    let clsValidacao = new ClsValidacao()

    retorno = clsValidacao.naoVazio('descricao', dados, erros, retorno)
    retorno = clsValidacao.naoVazio('campo', dados, erros, retorno)
    retorno = clsValidacao.naoVazio('grupo', dados, erros, retorno)

    setErros(erros)

    return retorno

  }

  const clsCrud: ClsCrud<DrgCorrespondenciaInterface> = new ClsCrud(
    navigate,
    ResetDados,
    setStatusForm,
    setDados,
    setErros,
    mensagemState,
    setMensagemState,
    setRsPesquisa,
    contexto,
    validarDados,
    {
      confirmarMutation: 'updateDrgCorrespondencia',
      excluirMutation: 'delDrgCorrespondencia',
      campoId: 'idDrgCorrespondencia',
      camposPesquisa: '{idDrgCorrespondencia descricao campo grupo valorUnico conteudoPermitido {chave descricaoConteudo} }',
      pesquisaQuery: 'getDrgCorrespondencias',
      pesquisaPorId: 'getDrgCorrespondenciaPorId',
      camposPesquisaPorId: '{idDrgCorrespondencia descricao campo grupo valorUnico conteudoPermitido {chave descricaoConteudo} }'
    },
    {
      confirmando: 'Atualizando Correspondência',
      erroCadastro: 'Erro ao Cadastrar Correspondência',
      erroExclusao: 'Erro ao Excluir Correspondência',
      erroPesquisa: 'Erro ao Pesquisar Correspondência',
      pesquisando: 'Pesquisando Dados de Correspondências...',
      sucessoCadastro: 'Correspondência Cadastrada com sucesso!',
      atualizacaoSucesso: 'Correspondência Atualizada com sucesso!',
      tituloConfirmado: 'Confirmada!',
      sucessoExclusao: 'Correspondência Excluída com sucesso...',
      tituloConfirmacaoExclusao: 'Confirma?',
      tituloErroCadastro: 'Erro!',
      tituloErroExclusao: 'Erro!',
      tituloErroPesquisa: 'Erro!',
      excluindo: 'Excluindo Correspondência...'
    }
  )

  const onKeyPesquisa = () => {
    clsCrud.onClickPesquisa(pesquisa.descricao, mensagemState)
  }

  // Dados para detalhe de parametros em JSON - Campo Valores

  const resetConteudoPermitido: DrgConteudoPermitidoInterface = {
    chave: '',
    descricaoConteudo: ''
  }

  const [conteudoPermitido, setConteudoPermitido] = useState<Array<DrgConteudoPermitidoInterface>>(dados.conteudoPermitido ? dados.conteudoPermitido : [])

  const CabecalhoConteudoPermitido: Array<DataTableCabecalhoInterface> = [
    {
      campo: 'descricaoConteudo',
      cabecalho: 'Descrição',
      alinhamento: 'left'
    },
    {
      campo: 'chave',
      cabecalho: 'DRG',
      alinhamento: 'left'
    }
  ]

  const onChangeConteudoPermitido = (v: Array<DrgConteudoPermitidoInterface>) => {
    setDados({ ...dados, conteudoPermitido: v })
  }

  // FINAL ============ Dados para detalhe de parametros em JSON - Campo Valores

  useEffect(() => {
    setConteudoPermitido(dados.conteudoPermitido ? dados.conteudoPermitido : [])
  }, [JSON.stringify(dados.conteudoPermitido)])

  return (
    <>
      <Container maxWidth="md" sx={{ mt: 5 }}>

        <Paper variant="outlined" sx={{ padding: 2 }}>
          <Grid container sx={{ display: 'flex', alignItems: 'stretch' }}>

            <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'space-between', mb: 3 }}>
              <Typography component="h5" variant="h5" align="left">
                Cadastro de Correspondências
                <Typography variant="body2" gutterBottom>
                  {TituloForm[statusForm]}
                </Typography>
              </Typography>

              <IconButton onClick={() => clsCrud.btFechar()}>
                <CloseIcon />
              </IconButton>
            </Grid>

            <Condicional condicao={statusForm === StatusForm.Pesquisando}>

              <Grid item xs={12} sm={10} sx={{ mb: 3 }}>

                <InputText
                  dados={pesquisa}
                  field='descricao'
                  label='Pesquisar'
                  setState={setPesquisa}
                  iconeEnd="search"
                  onClickIconeEnd={() => clsCrud.onClickPesquisa(pesquisa.descricao, mensagemState)}
                  mapKeyPress={[{ key: 'Enter', onKey: onKeyPesquisa }]}
                />

              </Grid>

              <Grid item xs={12} sm={2} alignSelf='center' sx={{ mt: { xs: 0, sm: 2 }, textAlign: { xs: 'right', sm: 'center' } }}>
                <Button variant='contained' onClick={() => clsCrud.btIncluir()}>Incluir</Button>
              </Grid>

            </Condicional>

            <Condicional condicao={statusForm !== StatusForm.Pesquisando}>

              <Grid item xs={12}>

                <ComboBox
                  dados={dados}
                  field='grupo'
                  label='Grupo'
                  setState={setDados}
                  disabled={statusForm === StatusForm.Excluindo}
                  erros={erros}
                  campoDescricao='descricao'
                  campoID='descricao'
                  opcoes={GrupoDRGTypes}
                />

              </Grid>

              <Grid item xs={12} md={6}>

                <InputText
                  dados={dados}
                  field='descricao'
                  label='Descrição'
                  setState={setDados}
                  disabled={statusForm === StatusForm.Excluindo}
                  erros={erros}
                  maxLength={50}
                />

              </Grid>

              <Grid item xs={12} md={6} sx={{ pl: { md: 1 } }}>

                <InputText
                  dados={dados}
                  field='campo'
                  label='Nome do Campo'
                  setState={setDados}
                  disabled={statusForm === StatusForm.Excluindo}
                  erros={erros}
                  maxLength={30}
                />

              </Grid>

              <Grid item xs={12} sx={{ textAlign: 'right', mt: 2 }}>

                <InputText
                  dados={dados}
                  tipo='checkbox'
                  field='valorUnico'
                  label='Valor Único'
                  setState={setDados}
                  disabled={statusForm === StatusForm.Excluindo}
                  erros={erros}
                  labelPlacement='start'
                />

              </Grid>

              <Grid item xs={12}>
                <DataTableCrudJSON<DrgConteudoPermitidoInterface>
                  dadosIniciaisRegistro={resetConteudoPermitido}
                  cabecalho={CabecalhoConteudoPermitido}
                  dados={conteudoPermitido}
                  ComponenteInputCrud={DrgCorrespondenciaDetalheJSON}
                  setState={setConteudoPermitido}
                  tituloCrud='Conteúdo Permitido'
                  onChange={onChangeConteudoPermitido}
                  disabled={statusForm === StatusForm.Excluindo}
                />
              </Grid>

              <Grid item xs={12} sx={{ mt: 3 }}>

                <Condicional condicao={statusForm === StatusForm.Excluindo}>
                  <Button variant='contained' startIcon={<CheckIcon />} sx={{ my: 1, py: 1, mr: 2 }} onClick={() => clsCrud.btConfirmarExclusao(dados, mensagemState, pesquisa.descricao)}>Confirmar</Button>
                </Condicional>

                <Condicional condicao={statusForm !== StatusForm.Excluindo}>
                  <Button variant='contained' startIcon={<CheckIcon />} sx={{ my: 1, py: 1, mr: 2 }} onClick={() => clsCrud.btConfirmar(dados, mensagemState, statusForm, pesquisa.descricao)}>Confirmar</Button>
                </Condicional>

                <Button variant='contained' startIcon={<CloseIcon />} sx={{ py: 1 }} onClick={() => clsCrud.btCancelar()}>Cancelar</Button>

              </Grid>

            </Condicional>

            <Condicional condicao={statusForm === StatusForm.Pesquisando}>
              <Grid item xs={12} sx={{ mt: 3 }}>
                <DataTable dados={rsPesquisa} cabecalho={Cabecalho} acoes={[
                  { icone: 'delete', toolTip: 'Excluir', onAcionador: clsCrud.btExcluir },
                  { icone: 'create', toolTip: 'Alterar', onAcionador: clsCrud.btEditar }]} />
              </Grid>
            </Condicional>

            <ExibirJSONDev exibir={EMDESENVOLVIMENTO} oque={['Dados', dados, 'Conteúdo Permitido', conteudoPermitido]} />

          </Grid>
        </Paper>

      </Container>
    </>
  )
}